import { forwardRef, useImperativeHandle, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// import { useMutation, useQuery } from 'react-query';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
// import { yupResolver } from '@hookform/resolvers/yup';

// import { createRequestUpdateValidationSchema } from 'features/ReviseProjectProposal/validation';
import { useMutation } from 'react-query';
import { DatePicker, TextInput } from 'components/FormControl';
// import Loading from 'components/Loading';
import { TOAST } from 'constant';
import { toast } from 'layout';
import { mapError } from 'utils/func';
import { createContract } from 'apis/projects.api';

// const formOptions = { resolver: yupResolver(createRequestUpdateValidationSchema) };

const CreateContractForm = forwardRef((props, ref) => {
  // #region Data
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [projectProposal, setprojectProposal] = useState(null);
  // const [updateRequestsDialogVisible, setUpdateRequestsDialogVisible] = useState(false);

  const {
    handleSubmit,
    control,
    trigger,
    reset,
    formState: { errors, dirtyFields },
  } = useForm({ mode: 'onChange' });

  const { mutate: mutateCreateContract } = useMutation(createContract);

  // #endregion

  // #region Event

  useImperativeHandle(ref, () => ({
    openDialog: (_projecProposal) => {
      setprojectProposal(_projecProposal);
      setVisible(true);
    }
  }));

  const onSubmit = (data) => {
    // eslint-disable-next-line no-param-reassign
    Object.keys(data).forEach((key) => { data[key] = data[key].toString(); });
    const datasender = { projectProposalId: projectProposal?.id.toString(),
      ...data };

    mutateCreateContract(datasender, {
      onSuccess: () => {
        toast(TOAST.SUCCESS);
        reset();
        setVisible(false);
      },
      onError: (error) => {
        toast(TOAST.ERROR, mapError(t, error));
      },
    });
  };

  const checkFormValid = async () => {
    const isValid = await trigger();
    if (!isValid) toast(TOAST.ERROR, t('errorMessage.validationErrorMessage'));
  };
  // #endregion

  return (
    <Dialog
      header={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <div className="flex justify-content-between">Tạo hợp đồng</div>
      }
      visible={visible}
      style={{ width: '700px' }}
      onHide={() => {
        reset();
        setVisible(false);
      }}
    >
      <div className="relative">
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="p-fluid flex flex-column"
          autoComplete="off"
        >
          <div className="grid">
            <div className="col-12 mb-2">
              <TextInput
                label="Tổng kinh phí thực hiện đề tài (đ)"
                name="totalExpenditure"
                control={control}
                errors={errors}
                isRequired
              />
            </div>
            <div className="col-12 mb-2">
              <TextInput
                label="Kinh phí từ ngân sách nhà nước (đ)"
                name="expenditureFromVNU"
                control={control}
                errors={errors}
                isRequired
              />
            </div>
            <div className="col-12 mb-2">
              <TextInput
                label="Kinh phí khoán (đ)"
                name="fixedExpenditure"
                control={control}
                errors={errors}
                isRequired
              />
            </div>
            <div className="col-12 mb-2">
              <TextInput
                label="Kinh phí không giao khoán (đ)"
                name="flexibleExpenditure"
                control={control}
                errors={errors}
                isRequired
              />
            </div>
            <div className="col-12 mb-2">
              <TextInput
                label="Kinh phí từ nguồn khác (đ)"
                name="expenditureFromFunding"
                control={control}
                errors={errors}
                isRequired
              />
            </div>
            <div className="col-12 mb-2">
              <TextInput
                label="Mã hợp đồng"
                name="code"
                control={control}
                errors={errors}
                isRequired
              />
            </div>
            <div className="col-12 mb-2">
              <DatePicker
                label="Ngày hiệu lực"
                name="effectiveDate"
                control={control}
                errors={errors}
                isRequired
              />
            </div>
          </div>

          <div className="grid mt-2">
            <div className="col-6">
              <Button
                label={t('formLayout.action.cancel')}
                type="button"
                severity="danger"
                onClick={() => {
                  reset();
                  setVisible(false);
                }}
              />
            </div>
            <div className="col-6">
              <Button
                label="Tạo hợp đồng"
                icon="pi pi-pencil"
                className="bg-cyan-400 border-cyan-400 hover:bg-cyan-500"
                type="submit"
                onClick={checkFormValid}
                disabled={
                  !(Object.keys(dirtyFields)?.length > 0)
                }
              />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
});

export default CreateContractForm;

CreateContractForm.propTypes = {};
